//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import libUmum from '../../library/umum'




export default {
  data() {
    return {
      

      form : {
        id : '',
        uraian : '',
        keterangan : '',
        jenis : 1,
        status : 1
      },

      opsi : {
        id : '',
        masterkuesionerevaluasi : 0,
        uraian : '',
        bobot : 0,

      },
     
      list_data : [],
      list_opsi : [],


      page_first: 1,
      page_last: 0,
      cari_value: "",
      cek_load_data : true,


      mdl_add: false,
      mdl_edit: false,
      mdl_hapus : false,

      mdl_list_opsi :false,
      mdl_add_opsi : false,
      mdl_edit_opsi : false,

      btn_add: false,

      LIB :libUmum

    }
  },
  methods: {
    


    getView : function(){
      // this.$store.commit("shoWLoading");
      fetch(this.$store.state.url.URL_masterKuesionerEvaluasi + "view", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              data_ke: this.page_first,
              cari_value: this.cari_value
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_data = res_data.data;
              this.page_last = res_data.jml_data;
              // this.$store.commit("hideLoading");
              console.log(res_data);
      });
    },


    addData : function(number) {
     
     

      fetch(this.$store.state.url.URL_masterKuesionerEvaluasi + "Add", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
          this.getView();
      });
      // console.log(this.form.jeniskategorilokasi)
    },


    editData : function(){
      fetch(this.$store.state.url.URL_masterKuesionerEvaluasi + "editData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify(this.form)
      }).then(res_data => {
          this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
          this.getView();
      });
    },

    removeData : function(E){
      fetch(this.$store.state.url.URL_masterKuesionerEvaluasi + "removeData", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({id : this.form.id})
      }).then(res_data => {
          this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
          this.getView();
      });

    },
    selectData : function(data){
      this.form = {
        id : data.id,
        uraian : data.uraian,
        keterangan : data.keterangan,
        jenis : data.jenis,
        status : data.status,
      };

      this.opsi.masterkuesionerevaluasi = data.id;
      this.viewOpsi();
    },

    // ================================== TAMBAHAN =======================================
        addOpsi : function() {
          fetch(this.$store.state.url.URL_masterKuesionerEvaluasi + "addOpsi", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.opsi)
          }).then(res_data => {
              this.Notify('Sukses Menambah Data', 'primary', 'check_circle_outline');
              this.viewOpsi();
          });
          // console.log(this.form.jeniskategorilokasi)
        },

        removeOpsi : function(data) {
          fetch(this.$store.state.url.URL_masterKuesionerEvaluasi + "removeOpsi", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({id : data.id})
          }).then(res_data => {
              this.Notify('Sukses Menghapus Data', 'negative', 'check_circle_outline');
              this.viewOpsi();
          });
          // console.log(this.form.jeniskategorilokasi)
        },

        editOpsi : function() {
          fetch(this.$store.state.url.URL_masterKuesionerEvaluasi + "editOpsi", {
              method: "POST",
              headers: {
                "content-type": "application/json",
                authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify(this.opsi)
          }).then(res_data => {
              this.Notify('Sukses Merubah Data', 'warning', 'check_circle_outline');
              this.viewOpsi();
          });
          // console.log(this.form.jeniskategorilokasi)
        },

        viewOpsi : function(){
          // this.$store.commit("shoWLoading");
          fetch(this.$store.state.url.URL_masterKuesionerEvaluasi + "viewOpsi", {
              method: "POST",
              headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
              },
              body: JSON.stringify({
                  masterkuesionerevaluasi: this.opsi.masterkuesionerevaluasi,
              })
          })
              .then(res => res.json())
              .then(res_data => {
                  this.list_opsi = res_data;
                  console.log(res_data);
          });
        },

        


        selectOpsi : function(data){
          this.opsi = {
            id : data.id,
            masterkuesionerevaluasi : data.masterkuesionerevaluasi,
            uraian : data.uraian,
            bobot : data.bobot

          }
        },




    // ====================================== PAGINATE ====================================
        Notify : function(message, positive, icon){
          this.$q.notify({
            message: message,
            color: positive,
            icon: icon,
            position : 'top',
            timeout: 500,
          })
        },
        btn_prev : function(){
            this.cek_load_data = true;
            if(this.page_first>1){
                this.page_first--
            }else{
                this.page_first = 1;
            }
            this.getView();
        },

        btn_next : function(){
            if(this.page_first >= this.page_last){
                this.page_first == this.page_last
            }else{
                this.page_first++;
            }
            this.getView();
        },

        cari_data : function(){
            this.page_first = 1;
            this.getView();
        },

        indicatorColor : function(data){
          if (data == 0) {
            return {
              bg : `bg-orange-2`,
              status : false
            }  
          }
          else if(data == 1){
            return {
              bg : `bg-blue-1`,
              status : false
            }
          }
          else if (data == 2){
            return {
              bg : `bg-red-2`,
              status : true
            }
          }

        }


    // ====================================== PAGINATE ====================================







  },

  mounted () {
    this.getView();
    // this.$store.commit("listJeniskategorilokasi");
    // this.$store.commit("getStorage");

  },
}
